import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP9BudgetCappedReorder202601: FaireAdPerformancePeriodEntity = {
  token: "perf_p9_budget_capped_reorder_202601",
  type: "adPerformancePeriod",
  scope: "REORDER_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2026-01-01",
  endDate: "2026-01-31",
  impressions: 9492,
  clicks: 177,
  adsSpendDollars: 596,
  budgetDollars: 900,
  salesDollars: 4841,
  bestEstimateRoas: 8.12,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.66,
  reorderConversions: 20,
  dataAvailableAtDate: "2026-02-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
